import PropTypes from "prop-types";

import { Box, Divider, IconButton, InputBase, Paper } from "@mui/material";
import { searchBidGroup } from "../../util/bid/searchBidGroup";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import CancelIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";
import { getUnionContractGivenWorkgroup } from "../../util/workgroupMapper";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  searchCounter: {
    fontSize: "13px",
    color: "gray",
    marginLeft: "10px",
  },
}));

const BidGroupSearchBox = (props) => {
  const classes = useStyles();

  const SearchCancelButton = () => {
    return (
      <IconButton sx={{ p: 0 }} size="small" className="cancel-icon-button" onMouseDown={handleSearchCancel}>
        <CancelIcon />
      </IconButton>
    );
  };

  const SearchButton = () => {
    return (
      <IconButton
        sx={{ p: 0 }}
        size="small"
        className="search-icon-button"
        onMouseDown={() => handleSearchSubmit(props.searchString)}
      >
        <SearchIcon />
      </IconButton>
    );
  };

  const applySearch = (newSearchString, searchedEmployeesList) => {
    if (newSearchString === "") {
      props.setIsSearch(false);
      props.setCurrSearchedEmployeesIdx(-1);
    } else {
      props.setIsSearch(true);
      if (searchedEmployeesList.length > 0) {
        props.setCurrSearchedEmployeesIdx(0);
      } else {
        props.setCurrSearchedEmployeesIdx(-1);
      }
      props.setSearchedEmployees(searchedEmployeesList);
    }
  };

  const handleSearchSubmit = (newSearchString) => {
    const newSearchStringTrimmed = newSearchString.trim().toLowerCase();
    searchBidGroup({
      searchString: newSearchStringTrimmed,
      applySearchCallback: applySearch,
      contract: getUnionContractGivenWorkgroup(props.bid.workgroup),
      workgroup: props.bid.workgroup,
    });
  };

  const handleSearchChange = (event) => {
    if (event.target.value === "") {
      handleSearchCancel();
    }

    if (props.searchString.length !== event.target.value.length) {
      props.setIsSearch(false);
    }

    props.setSearchString(event.target.value);
  };

  const handleSearchBlur = (event) => {
    if (event.target.value.trim() === "") {
      handleSearchSubmit("");
    }
  };

  const handleSearchCancel = () => {
    props.setSearchString("");
    props.setIsSearch(false);
    props.setCurrSearchedEmployeesIdx(-1);
    props.setSearchedEmployees([]);
    handleSearchSubmit("");
  };

  const handleSearchEnterKeyPressed = (event) => {
    if (event.key === "Enter") {
      if (props.isSearch) {
        if (props.currSearchedEmployeesIdx !== -1) {
          handleSearchDownArrowClick();
        }
      } else {
        handleSearchSubmit(event.target.value);
      }
    }
  };

  const handleSearchUpArrowClick = () => {
    if (props.currSearchedEmployeesIdx === 0) {
      props.setCurrSearchedEmployeesIdx(props.searchedEmployees.length - 1);
    } else {
      props.setCurrSearchedEmployeesIdx(props.currSearchedEmployeesIdx - 1);
    }
  };

  const handleSearchDownArrowClick = () => {
    if (props.currSearchedEmployeesIdx === props.searchedEmployees.length - 1) {
      props.setCurrSearchedEmployeesIdx(0);
    } else {
      props.setCurrSearchedEmployeesIdx(props.currSearchedEmployeesIdx + 1);
    }
  };

  const renderSearchBox = () => {
    return (
      <Box sx={{ paddingRight: "10px" }}>
        <Paper
          elevation={0}
          variant="outlined"
          sx={{ p: "2px 4px", display: "flex", alignItems: "center", width: "265px" }}
        >
          <InputBase
            sx={{ ml: 1, flex: 1 }}
            placeholder="Search"
            value={props.searchString}
            onChange={handleSearchChange}
            onBlur={handleSearchBlur}
            onKeyUp={handleSearchEnterKeyPressed}
          />
          {props.searchString !== "" ? (
            <>
              <div className={classes.searchCounter}>
                {props.currSearchedEmployeesIdx + 1}/{props.searchedEmployees.length}
              </div>
              <IconButton sx={{ p: "0" }} type="button" aria-label="search">
                <SearchCancelButton />
              </IconButton>
              <IconButton
                sx={{ paddingTop: "0", paddingBottom: "0", paddingLeft: "0", paddingRight: "10px" }}
                type="button"
                aria-label="search"
              >
                <SearchButton />
              </IconButton>
            </>
          ) : (
            <IconButton sx={{ p: "0" }} type="button" aria-label="search">
              <SearchIcon />
            </IconButton>
          )}

          <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
          <IconButton
            sx={{ p: "0" }}
            disabled={!props.isSearch || props.searchedEmployees.length === 0}
            onClick={handleSearchUpArrowClick}
          >
            <ArrowDropUpIcon />
          </IconButton>
          <IconButton
            sx={{ p: "0" }}
            disabled={!props.isSearch || props.searchedEmployees.length === 0}
            onClick={handleSearchDownArrowClick}
          >
            <ArrowDropDownIcon />
          </IconButton>
        </Paper>
      </Box>
    );
  };

  return <div>{renderSearchBox()}</div>;
};

BidGroupSearchBox.propTypes = {
  bid: PropTypes.object.isRequired,
  searchString: PropTypes.string.isRequired,
  setSearchString: PropTypes.func.isRequired,
  isSearch: PropTypes.bool.isRequired,
  setIsSearch: PropTypes.func.isRequired,
  searchedEmployees: PropTypes.array.isRequired,
  setSearchedEmployees: PropTypes.func.isRequired,
  currSearchedEmployeesIdx: PropTypes.number.isRequired,
  setCurrSearchedEmployeesIdx: PropTypes.func.isRequired,
};

export default BidGroupSearchBox;
